import { Grid, Container, Box, IconButton } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useStyles } from "../style";
import { Button } from "primereact/button";
import { APP_URLS } from "../../../../utils/constant";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import EzControlledPasswordWithFloatingLabel from "../../../../common/EzForm/EZControlledPassword/WithFloatingLabel";
import EzControlledDropDown from "../../../../common/EzForm/EzControlledDropDown";
import EzControlledMultiSelect from "../../../../common/EzForm/EzControlledMultiSelect";
import EzControlledCheckBox from "../../../../common/EzForm/EzControlledCheckBox";
import { useForm } from "react-hook-form";
import "./index.css";
import { Status, transformFormFieldValueMap, UserBreadcrumb, editMode } from "./constant";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import EzControlledMultiSelecttWithFloatingLabel from "../../../../common/EzForm/EzControlledMultiSelect/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useNavigate } from "react-router-dom";

const CreateUsersComponent = (props) => {
  const navigate = useNavigate();
  const {
    isEdit,
    formFieldValueMap,
    isUsersDetailSuccess,
    updateUser,
    isLoading,
    createUser,
    isUpdateUserSuccess,
    isUserCreateSuccess,
    UserRolesDD,
    LocationsDD,
    CompaniesDD,
    fetchUserRolesDD,
    fetchLocationsDD,
    shouldBlockNavigation,
  } = props;
  const {
    control,
    formState: { errors, isDirty },
    setValue,
    handleSubmit,
    reset,
    unregister,
  } = useForm({
    defaultValues: useMemo(
      () => transformFormFieldValueMap(formFieldValueMap),
      [formFieldValueMap],
    ),
  });
  const classes = useStyles();

  const [companyAccessRows, setCompanyAccessRows] = useState([
    {
      id: Date.now(),
      companyId: null,
      roleId: null,
      locationIds: [],
      isDefault: true,
      roles: [],
      locations: [],
    },
  ]);

  const [expandedCompanies, setExpandedCompanies] = useState(new Set());

  const toggleCompanyExpand = (companyId) => {
    setExpandedCompanies((prev) => {
      const next = new Set(prev);
      if (next.has(companyId)) {
        next.delete(companyId);
      } else {
        next.add(companyId);
      }
      return next;
    });
  };

  const visibleCompanyOptions = useMemo(() => {
    const visible = [];
    const buildVisible = (companies, depth) => {
      companies.forEach((company) => {
        const hasChildren = company.childCompanies?.length > 0;
        visible.push({
          companyId: company.companyId,
          companyName: company.companyName,
          _hasChildren: hasChildren,
          _depth: depth,
        });
        if (hasChildren && expandedCompanies.has(company.companyId)) {
          buildVisible(company.childCompanies, depth + 1);
        }
      });
    };
    buildVisible(CompaniesDD || [], 0);
    return visible;
  }, [CompaniesDD, expandedCompanies]);

  const companyItemTemplate = (option) => {
    if (!option) return null;
    const isExpanded = expandedCompanies.has(option.companyId);
    const iconStyle = { fontSize: 20, color: "#555" };
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          paddingLeft: `${(option._depth || 0) * 20}px`,
        }}
      >
        <span style={{ flex: 1, textAlign: "left" }}>{option.companyName}</span>
        {option._hasChildren && (
          <span
            onClick={(e) => {
              e.stopPropagation();
              toggleCompanyExpand(option.companyId);
            }}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              marginTop: "3px",
              width: "24px",
              height: "24px",
            }}
          >
            {isExpanded ? (
              <KeyboardArrowDownIcon sx={iconStyle} />
            ) : (
              <KeyboardArrowRightIcon sx={iconStyle} />
            )}
          </span>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (isUsersDetailSuccess) {
      reset(transformFormFieldValueMap(formFieldValueMap));

      if (formFieldValueMap?.companyAccess?.length) {
        const companyIdsInAccess = new Set(
          formFieldValueMap.companyAccess.map((item) => item.companyId)
        );

        const findAncestorIds = (companies, targetId, path = []) => {
          for (const company of companies) {
            if (company.companyId === targetId) return path;
            if (company.childCompanies?.length > 0) {
              const result = findAncestorIds(
                company.childCompanies,
                targetId,
                [...path, company.companyId]
              );
              if (result !== null) return result;
            }
          }
          return null;
        };
        const parentsToExpand = new Set();
        companyIdsInAccess.forEach((id) => {
          const ancestors = findAncestorIds(CompaniesDD || [], id);
          ancestors?.forEach((ancestorId) => parentsToExpand.add(ancestorId));
        });
        if (parentsToExpand.size > 0) {
          setExpandedCompanies(parentsToExpand);
        }

        const fetchRows = async () => {
          const rows = await Promise.all(
            formFieldValueMap.companyAccess.map(async (item) => {
              const [fetchedRoles, fetchedLocations] = await Promise.all([
                fetchUserRolesDD(item.companyId),
                fetchLocationsDD(item.companyId),
              ]);

              return {
                id: item.companyId,
                companyId: item.companyId,
                roleId: item.roles?.[0]?.roleId || null,
                locationIds: item.locations?.map((loc) => loc.locationId) || [],
                isDefault: item.default,
                roles: fetchedRoles || [],
                locations: fetchedLocations || [],
              };
            }),
          );
          setCompanyAccessRows(rows);
          rows.forEach((row) => {
            setValue(`companyId_${row.id}`, row.companyId);
            setValue(`roleId_${row.id}`, row.roleId);
            setValue(`locationIds_${row.id}`, row.locationIds);
            setValue(`isDefault_${row.id}`, row.isDefault);
          });
        };
        fetchRows();
      }
    }
  }, [isUsersDetailSuccess, formFieldValueMap, reset]);

  useEffect(() => {
    if (isUpdateUserSuccess || isUserCreateSuccess) {
      reset();
    }
  }, [isUpdateUserSuccess, isUserCreateSuccess, reset]);

  const handleAddNewRole = () => {
    setCompanyAccessRows([
      ...companyAccessRows,
      {
        id: Date.now(),
        companyId: null,
        roleId: null,
        locationIds: [],
        isDefault: false,
        roles: [],
        locations: [],
      },
    ]);
  };

  const handleDeleteRole = (id) => {
    if (companyAccessRows.length > 1) {
      const remaining = companyAccessRows.filter((row) => row.id !== id);
      const deletedRow = companyAccessRows.find((row) => row.id === id);
      if (deletedRow?.isDefault && remaining.length > 0) {
        remaining[0] = { ...remaining[0], isDefault: true };
      }
      unregister([`companyId_${id}`, `roleId_${id}`, `locationIds_${id}`, `isDefault_${id}`]);
      setCompanyAccessRows(remaining);
    }
  };

  const handleRowChange = async (id, field, value) => {
    if (field === "companyId" && value) {
      const roles = await fetchUserRolesDD(value);
      const locations = await fetchLocationsDD(value);

      setValue(`roleId_${id}`, null);
      setValue(`locationIds_${id}`, []);
      setCompanyAccessRows(
        companyAccessRows.map((row) =>
          row.id === id
            ? {
                ...row,
                [field]: value,
                roleId: null,
                locationIds: [],
                roles: roles || [],
                locations: locations || [],
              }
            : row,
        ),
      );
    } else if (field === "isDefault" && value === true) {
      // Only one row can be default — clear all others
      setCompanyAccessRows(
        companyAccessRows.map((row) =>
          row.id === id ? { ...row, isDefault: true } : { ...row, isDefault: false },
        ),
      );
    } else {
      setCompanyAccessRows(
        companyAccessRows.map((row) =>
          row.id === id ? { ...row, [field]: value } : row,
        ),
      );
    }
  };

  const onSubmit = (formData) => {
    const idValue = isEdit ? Number(formData.id) : null;

    const payload = {
      id: idValue,
      username: formData.username,
      password: formData.password,
      alias: formData.alias,
      status: formData.status,
      companyAccess: companyAccessRows.map((row) => ({
        companyId: row.companyId,
        roleIds: row.roleId ? [row.roleId] : [],
        locationIds: row.locationIds || [],
        isDefault: row.isDefault,
      })),
    };

    if (isEdit) {
      updateUser({ id: idValue, data: payload });
    } else {
      createUser(payload);
    }
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const renderPageHeaderSection = () => (
    <div className="make-relative sub-header">
      <div className="maintitlediv">
        <div className="ml-3">
          <h4 className="pagetitle">
            {isEdit
              ? "Update User"
              : "Create User"}
          </h4>
        </div>
        <div className="buttonarea">
          <Button
            tooltip={"Back to Users"}
            tooltipOptions={{ position: "left" }}
            label={"Back to Users"}
            className={`p-button `}
            style={{ borderRadius: "10px" }}
            onClick={() => navigate(APP_URLS.SYSTEM_USERS.HOME)}
          />
        </div>
      </div>
    </div>
  );
  return (
    <Container maxWidth="lg">
      <Breadcrumb list={UserBreadcrumb} />
      <EzToast
        severity={TOAST_SEVERITY.ERROR}
        toastTitle="Please select category from list"
        shouldShowToast={false}
      />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo" style={{ marginTop: "10px" }}>
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6} md={3}>
                <EzControlledInputWithFloatingLabel
                  name="username"
                  control={control}
                  label="Username"
                  isError={errors["username"]}
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE_MESSAGE}
                  errorMsg={getFormErrorMessage("username")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <EzControlledPasswordWithFloatingLabel
                  name="password"
                  type="password"
                  control={control}
                  label="Password"
                  isError={errors["password"]}
                  errorMsg={getFormErrorMessage("password")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <EzControlledDropDowntWithFloatingLabel
                  name="status"
                  control={control}
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  optionLabel="name"
                  optionValue="id"
                  options={Status}
                  isError={errors["status"]}
                  errorMsg={getFormErrorMessage("status")}
                  label="Status"
                  labelClassName={"ml-2"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <EzControlledInputWithFloatingLabel
                  name="alias"
                  control={control}
                  label="Alias"
                  isError={errors["alias"]}
                  errorMsg={getFormErrorMessage("alias")}
                />
              </Grid>
            </Grid>

            <div
              style={{
                width: "100%",
                height: "1px",
                backgroundColor: "#e0e0e0",
                margin: "0px 0px 30px 0px",
              }}
            />

            <Box sx={{ mb: 3 }}>
              <Grid
                container
                spacing={2}
                sx={{ mb: 1, fontWeight: "bold", color: "#666" }}
              >
                <Grid item xs={12} sm={3} md={3}>
                  Company <span style={{ color: "red" }}>*</span>
                </Grid>
                <Grid item xs={12} sm={3} md={3}>
                  Role <span style={{ color: "red" }}>*</span>
                </Grid>
                <Grid item xs={12} sm={3} md={2.5}>
                  Location <span style={{ color: "red" }}>*</span>
                </Grid>
                <Grid item xs={12} sm={2} md={2.5}></Grid>
                <Grid item xs={12} sm={1} md={1}></Grid>
              </Grid>

              {companyAccessRows.map((row, index) => (
                <Grid
                  container
                  spacing={2}
                  key={row.id}
                  sx={{ mb: 2, alignItems: "center" }}
                >
                  <Grid item xs={12} sm={3} md={3}>
                    <EzControlledDropDown
                      control={control}
                      name={`companyId_${row.id}`}
                      value={row.companyId}
                      options={visibleCompanyOptions}
                      optionLabel="companyName"
                      optionValue="companyId"
                      filterBy="companyName"
                      itemTemplate={companyItemTemplate}
                      rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE_MESSAGE}
                      onChange={(e) =>
                        handleRowChange(row.id, "companyId", e.value)
                      }
                    />
                    {errors[`companyId_${row.id}`] && (
                      <small className="p-error">{errors[`companyId_${row.id}`].message}</small>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3} md={3}>
                    <EzControlledDropDown
                      control={control}
                      name={`roleId_${row.id}`}
                      value={row.roleId}
                      onChange={(e) =>
                        handleRowChange(row.id, "roleId", e.value)
                      }
                      options={row.roles || []}
                      optionLabel="name"
                      optionValue="id"
                      rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE_MESSAGE}
                      disabled={!row.companyId}
                    />
                    {errors[`roleId_${row.id}`] && (
                      <small className="p-error">{errors[`roleId_${row.id}`].message}</small>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3} md={2.5}>
                    <EzControlledMultiSelect
                      control={control}
                      name={`locationIds_${row.id}`}
                      value={row.locationIds}
                      onChange={(e) =>
                        handleRowChange(row.id, "locationIds", e.value)
                      }
                      options={row.locations || []}
                      optionLabel="name"
                      optionValue="id"
                      placeholder="Select Location"
                      rules={getFormBaseValidationRule().MULTI_SELECT.VALIDATION_RULE}
                      disabled={!row.companyId}
                    />
                    {errors[`locationIds_${row.id}`] && (
                      <small className="p-error">{errors[`locationIds_${row.id}`].message}</small>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    md={2.5}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                    }}
                  >
                    <EzControlledCheckBox
                      control={control}
                      name={`isDefault_${row.id}`}
                      value={row.isDefault}
                      onChange={(e) =>
                        handleRowChange(row.id, "isDefault", e.checked)
                      }
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                      onClick={() =>
                        handleRowChange(row.id, "isDefault", !row.isDefault)
                      }
                    >
                      Is Default
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={1}
                    md={1}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <IconButton
                      onClick={() => handleDeleteRole(row.id)}
                      disabled={companyAccessRows.length === 1}
                      sx={{
                        color: "#ef4444",
                        "&:hover": { backgroundColor: "#fee2e2" },
                        "&.Mui-disabled": { color: "#d1d5db" },
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}

              <Button
                type="button"
                label="Add New Role"
                icon="pi pi-plus"
                onClick={handleAddNewRole}
                className="p-button-outlined"
                style={{ marginTop: "10px", width: "170px" }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 3,
              }}
            >
              <Button
                type="button"
                label="Cancel"
                className="p-button-secondary"
                style={{ width: "100px" }}
                onClick={() => navigate(APP_URLS.SYSTEM_USERS.HOME)}
              />
              <Button
                type="submit"
                label={isEdit ? "Update" : "Save"}
                className="p-button-raised"
                style={{ width: "100px" }}
                disabled={isLoading}
              />
            </Box>
            {isEdit && (
              <Grid className="modsection" container spacing={2} mt={4}>
                {editMode?.map((item) => (
                  <Grid item xs={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={item?.disabled}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>
    </Container>
  );
};

export default CreateUsersComponent;
